import { Colors } from "./types";

export const baseColors = {
  failure: "#ED4B9E",
  primary: "#002014", // Dark green
  primaryBright: "#003d28", // Lighter dark green
  primaryDark: "#002014", // Darker green
  secondary: "#000",
  success: "#002014", // Use primary dark green for success
  warning: "#FFB237",
};

export const additionalColors = {
  binance: "#002014", // Use primary dark green
  overlay: "#0a0e1a", // Use dark background
  gold: "#FFC700",
  silver: "#B2B2B2",
  bronze: "#E7974D",
};

export const lightColors: Colors = {
  ...baseColors,
  ...additionalColors,
  background: "#FFFFFF",
  backgroundDisabled: "#F5F5F5",
  backgroundAlt: "#FAFAFA",
  backgroundAlt2: "rgba(255, 255, 255, 0.7)",
  cardBorder: "#E0E0E0",
  contrast: "#0a0e1a", // Dark text on light bg
  dropdown: "#FFFFFF",
  dropdownDeep: "#F5F5F5",
  invertedContrast: "#0a0e1a",
  input: "#F5F5F5",
  inputSecondary: "#EEEEEE",
  tertiary: "#F0F0F0",
  text: "#0a0e1a", // Dark text
  textDisabled: "#BDC2C4",
  textSubtle: "#002014", // Dark green for subtle text
  disabled: "#E9EAEB",
  gradients: {
    bubblegum: "linear-gradient(139.73deg, #E8F5F0 0%, #D4EDE4 50%, #FFFFFF 100%)", // Light dark green tint
    inverseBubblegum: "linear-gradient(139.73deg, #FFFFFF 0%, #D4EDE4 50%, #E8F5F0 100%)",
    cardHeader: "linear-gradient(111.68deg, #E8F5F0 0%, #D4EDE4 50%, #FFFFFF 100%)",
    blue: "linear-gradient(180deg, #E0F0EC 0%, #B2D9D4 50%, #80C4BC 100%)", // Teal with dark green tint
    violet: "linear-gradient(180deg, #D4EDE4 0%, #B2D9D4 50%, #80C4BC 100%)",
    violetAlt: "linear-gradient(180deg, #C8E8DC 0%, #A0D4C4 50%, #80C4B0 100%)",
    gold: "linear-gradient(180deg, #FFD800 0%, #FDAB32 100%)",
  },
  white: "#fff",
  dark: "#000",
  menucolor: "#FFFFFF"
};

export const darkColors: Colors = {
  ...baseColors,
  ...additionalColors,
  secondary: "#FFF",
  background: "#024f32", // Darker background (DEFAULT)
  backgroundDisabled: "#1a1f2e", // Dark blue-gray background (light)
  backgroundAlt: "#000000", // Dark blue-gray background (light)
  backgroundAlt2: "#024f32", // Darkest background (dark)
  cardBorder: "#1a1f2e",
  contrast: "#FFFFFF",
  dropdown: "#1a1f2e",
  dropdownDeep: "#0f1419",
  invertedContrast: "#0f1419",
  input: "#0a0e1a",
  inputSecondary: "#1a1f2e",
  primaryDark: "#001408", // Darker green
  tertiary: "#0f1419",
  text: "#FFF",
  textDisabled: "#6c7284",
  textSubtle: "#FFFFFF", // White for readability on dark backgrounds
  disabled: "#1a1f2e",
  gradients: {
    bubblegum: "linear-gradient(139.73deg, #003d28 0%, #002014 50%, #0a0e1a 100%)", // Dark green to dark bg
    inverseBubblegum: "linear-gradient(139.73deg, #0a0e1a 0%, #002014 50%, #003d28 100%)",
    cardHeader: "linear-gradient(166.77deg, #003d28 0%, #002014 50%, #0a0e1a 98%)",
    blue: "linear-gradient(180deg, #002014 0%, #001a10 50%, #001408 100%)", // Dark green gradient
    violet: "linear-gradient(180deg, #002014 0%, #002a1c 50%, #001a10 100%)",
    violetAlt: "linear-gradient(180deg, #003d28 0%, #002014 50%, #001408 100%)",
    gold: "linear-gradient(180deg, #FFD800 0%, #FDAB32 100%)",
  },
  white: "#fff",
  dark: "#000",
  menucolor: "#0a0e1a" // Darker background
};
